// import RepositoryFactory from "@/apis";
// const Payment = RepositoryFactory.payment;
import Payment from "../../apis/payment";

export default {
  CreateOrderPayment({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Payment.create_order_payment(payload);
        // commit("CREATE_ORDER_PAYMENT", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  CreatePayment({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Payment.create_payment(payload);
        // commit("CREATE_PAYMENT", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  createFreePayment({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Payment.createFreePayment(payload);
        // commit("CREATE_PAYMENT", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  UpdatePayment({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Payment.update_payment(payload);
        // commit("UPDATE_PAYMENT", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getAllPayments({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Payment.getAllPayments(payload);
        commit("GET_ALL_PAYMENT", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
